// Action Types
export const SET_EMBEDDED_PLAYER_STREAM_CONTENT = 'SET_EMBEDDED_PLAYER_STREAM_CONTENT';
export const SET_EMBEDDED_PLAYER_STREAM_LOADING = 'SET_EMBEDDED_PLAYER_STREAM_LOADING';

// Action Creator
const EmbeddedPlayerStreamActionCreator = {
  setEmbeddedPlayerStreamContent(details: any) {
    return {
      type: SET_EMBEDDED_PLAYER_STREAM_CONTENT,
      payload: {
        ...details
      }
    };
  },
  setEmbeddedPlayerStreamLoading(loading: boolean) {
    return {
      type: SET_EMBEDDED_PLAYER_STREAM_LOADING,
      payload: {
        loading
      }
    };
  }
};

export default EmbeddedPlayerStreamActionCreator;
